import { render, staticRenderFns } from "./modalVincularEstudo.vue?vue&type=template&id=62235290"
import script from "./modalVincularEstudo.vue?vue&type=script&lang=js"
export * from "./modalVincularEstudo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports